import React, { useState, useEffect, useRef, useContext } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Dialog, Toast } from "primereact";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { confirmDialog } from "primereact/confirmdialog";
import { Dropdown } from "primereact/dropdown";

// ------------------ COMPONENTES DE BASE--------------------------
import AgGrid from "../../../../../Base/Components/Tables/AgGrid/AgGrid";
import { AuthContext } from "../../../../../Base/Context/AuthContext/AuthContext";
import { obtenerCountries } from "../../../../../Base/API/Global/Countries/CountriesRequests";
import { toastShow } from "../../../../../Base/Services/ToastService";
import Loader from "../../../../../Base/Components/Loader/Loader";

// ------------------- CONSULTAS A LA API---------------------------
import { cambiarEstadoCustomerD, getCustomersDetailsPorCustomer, GuardarCustomerDetails, putChecksCustomerDetails } from "../../../../../API/Compras/Customers/CustomerDetails/CustomerDetailsRequest";
import { getEstadosCategory } from "../../../../../API/Global/Status/StatusRequests";

const CompradoresDialog = ({
  dialogCustomersD,
  selected,
  setDialogCustomersD,
}) => {

  const toastDialog = useRef(null);
  const toast = useRef(null);
  const { userAuth } = useContext(AuthContext)
  const [paises, setPaises] = useState([]);
  const [estados, setEstados] = useState([]);
  const [detalles, setDetalles] = useState([]);
  const [selectedDetalles, setSelectedDetalles] = useState([]);
  const [loading, setLoading] = useState(false);


  const getInfo = async () => {
    setLoading(true)
    const dataTempo = await getCustomersDetailsPorCustomer(selected?.IdCustomer)
    const paisesTempo = await obtenerCountries()
    const estadosTempo = await getEstadosCategory('General')
    setEstados(estadosTempo?.filter(i=> i?.IdStatus === 5 || i?.IdStatus === 6))
    setPaises(paisesTempo)
    setDetalles(dataTempo)
    setLoading(false)
  };

  const onHide = () => {
    setDialogCustomersD(false);
  };

  const changeValue = ({ data, column }) => {
    const index = detalles.findIndex((detail) => detail.IdCustomerDetails === data.IdCustomerDetails);
    
    if (index !== -1) {
      let newDetails = [...detalles];
      newDetails[index] = { ...newDetails[index], [column.field]: data[column.field] };
      setDetalles(newDetails);
    }
  };

  const onChangeCheck = async (valor, IdCustomerDetails, e) => {
    if(IdCustomerDetails > 0){
      let checkValores = {
        Valor: valor,
        Activo: e,
        IdDCustomer: IdCustomerDetails,
        IdCustomer: selected?.IdCustomer,
      }


      setLoading(true)
      const result = await putChecksCustomerDetails(checkValores)
      getInfo()
      setLoading(false)
    }else{
      setDetalles(prevDetalles =>
        prevDetalles.map(detail => {
          if (detail.IdCustomerDetails === IdCustomerDetails) {
            let updatedDetail = { ...detail };
            if (valor === 1) updatedDetail.IsBuyer = e;
            if (valor === 2) updatedDetail.IsShipTo = e;
            if (valor === 3) updatedDetail.IsBillTo = e;
            return updatedDetail;
          }
          return detail;
        })
      );
    }
  }

  const changePais = ({ data, oldValue, api }, column) => {
    return (
      <div>
        <Dropdown
          value={paises?.find((e) => e.IdCountry === data?.IdCountry)}
          options={paises}
          style={{ width: "100%", position: "relative" }}
          optionLabel="Country"
          filter
          filterBy="Country"
          clearIcon="pi pi-times"
          onChange={(e) => {
            if(selectedDetalles?.length > 1){
              let tempo2 = [...detalles]; 
              selectedDetalles.forEach((item) => {
                if (item?.IdCustomerDetails <= 0) { 
                  const index = tempo2.findIndex((detail) => detail.IdCustomerDetails === item.IdCustomerDetails);
                  if (index !== -1) {
                    tempo2[index] = {
                      ...tempo2[index],
                      IdCountry: e.value.IdCountry,
                      Country: e.value.Country
                    };
                  }
                }else{
                  let dataMayor = selectedDetalles?.filter((i)=> i?.IdCustomerDetails > 0)
                  let IdsMayor = dataMayor.map((i)=> i?.IdCustomerDetails).join(',')
                  console.log(IdsMayor);
                }
              });
              setDetalles(tempo2);
            }else{
              if(data?.IdCustomerDetails > 0){
                confirmDialog({
                  message: "¿Desea cambiar el país?",
                  header: "Cambiar País",
                  icon: "pi pi-exclamation-triangle",
                  acceptLabel: "Sí",
                  rejectLabel: "No",
                  style: { backgroundColor: "white" },
                  accept: async () => {
                    setLoading(true)
                    let Ids = data?.IdCustomerDetails
                    let IdCountry = e.value?.IdCountry;
                    const resp = 1 //await cambiarCountry(IdCountry, Ids)
                    if(resp){
                      toastShow(toast, "success", 'Cambiado',"País cambiado exitosamente");
                      setSelectedDetalles([])
                      getInfo()
                    }else{
                      toastShow(toast, "error", "Error al cambiar país");
                    }
                    setLoading(false)
                  },
                  reject: () => {},
                });
              }else{
                let tempo2 = [...detalles];
                const index = tempo2.findIndex((detail) => detail.IdCustomerDetails === data.IdCustomerDetails);
                if (index !== -1) {
                  tempo2[index] = { 
                    ...tempo2[index], 
                    IdCountry: e.value.IdCountry, 
                    Country: e.value.Country 
                  };
                  setDetalles(tempo2);
                }
              }
            }
              
          }}
        />
      </div>
    );
  };

  const changeEstado = ({ data, oldValue, api }, column) => {
    return (
        <div>
        <Dropdown
          value={estados?.find((e) => e.IdStatus === data?.IdStatus)[0]}
          options={estados}
          style={{ width: "100%", position: "relative" }}
          optionLabel="StatusName"
          filter
          filterBy="StatusName"
          clearIcon="pi pi-times"
          onChange={(e) => {
            if(data?.IdCustomerDetails > 0){
              confirmDialog({
                message: "¿Desea cambiar el estado?",
                header: "Cambiar Estado",
                icon: "pi pi-exclamation-triangle",
                acceptLabel: "Sí",
                rejectLabel: "No",
                style: { backgroundColor: "white" },
                accept: async () => {
                  setLoading(true)
                  let Ids
                  let IdStatus = e.value?.IdStatus;
                  if(selectedDetalles?.length > 0){
                    Ids = selectedDetalles.map(item => item.IdCustomerDetails).join(",");
                  }else{
                    Ids = data?.IdCustomerDetails
                  }

                  const resp = await cambiarEstadoCustomerD(IdStatus, Ids)
                  // console.log(resp);
                  if(resp){
                    toastShow(toast, "success", 'Cambiado',"Estado cambiado exitosamentee");
                    setSelectedDetalles([])
                    getInfo()
                  }else{
                    toastShow(toast, "error", "Error al cambiar estado de la Hilaza");
                  }
                  setLoading(false)
                },
                reject: () => {},
              });
            }else{
              let tempo2 = [...detalles];
              const index = tempo2.findIndex((detail) => detail.IdCustomerDetails === data.IdCustomerDetails);
              if (index !== -1) {
                tempo2[index] = { 
                  ...tempo2[index], 
                  IdStatus: e.value.IdStatus, 
                  StatusName: e.value.StatusName 
                };
                setDetalles(tempo2);
              }
            }
          }}
        />
        </div>
    );
  };

  const columns = [
    {
      field: "IdCustomerDetails",
      header: "ID",
      className: "small",
      hidden: userAuth?.IdRol === 1,
      className: "XXsmall",
    },

    {
      field: "StatusName",
      header: "Estado",
      className: "Xsmall",
      Format: "Template",
      Format: "Estado",
      body: (rowData) => ({ ID: rowData.IdStatus, Estado: rowData.StatusName }),
      Sumary: "count",
      editable: ({ data }) => data?.IdCustomerDetails > 0,
      cellEditor: changeEstado,
    },
    {
      field: "RTN",
      header: "RTN",
      className: "small",
      editable: true,
      onChange: (data) => changeValue(data),
    },
    {
      field: "CompanyName",
      header: "Compañia",
      className: "large",
      editable: true,
      onChange: (data) => changeValue(data),
    },
    {
      field: "Contact",
      header: "Contact",
      className: "medium",
      editable: true,
      onChange: (data) => changeValue(data),
    },
    {
      field: "Tel",
      header: "Tel",
      className: "medium",
      editable: true,
      onChange: (data) => changeValue(data),
    },
    {
      field: "Email",
      header: "Email",
      className: "medium",
      editable: true,
    },
    {
      field: "Country",
      header: "Country",
      className: "medium",
      editable: true,
      cellEditor: changePais,
    },
    {
      field: "City",
      header: "City",
      className: "small",
      editable: true,
      onChange: (data) => changeValue(data),
    },
    {
      field: "State",
      header: "State",
      className: "medium",
      editable: true,
      onChange: (data) => changeValue(data),
    },
    {
      field: "Address",
      header: "Direccion",
      className: "large",
      editable: true,
      onChange: (data) => changeValue(data),
    },
    {
      field: "IsBuyer",
      header: "IsBuyer",
      className: "small",
      Format: "Template",
      align: "center",
      body: (rowData) => rowData?.IdCustomerDetails && (<Checkbox onChange={(e) => onChangeCheck(1, rowData.IdCustomerDetails, e.checked)} style={{ marginBottom: 5 }} checked={rowData.IsBuyer} />),
    },
    {
      field: "IsShipTo",
      header: "IsShipTo",
      className: "small",
      Format: "Template",
      align: "center",
      body: (rowData) => rowData?.IdCustomerDetails && (<Checkbox onChange={(e) => onChangeCheck(2, rowData.IdCustomerDetails, e.checked)} style={{ marginBottom: 5 }} checked={rowData.IsShipTo} />),
    },
    {
      field: "IsBillTo",
      header: "IsBillTo",
      className: "small",
      Format: "Template",
      align: "center",
      body: (rowData) =>  rowData?.IdCustomerDetails && (<Checkbox onChange={(e) => onChangeCheck(3, rowData.IdCustomerDetails, e.checked)} style={{ marginBottom: 5 }} checked={rowData.IsBillTo} />),
    },
    // {
    //   field: "ZipCode",
    //   header: "ZipCode",
    //   className: "medium",
    // },
  ];

  const table = {
    Data: detalles,
    Columns: columns,
    key: 'IdCustomerDetails ',
    selected: selectedDetalles,
    setSelected: setSelectedDetalles,
  }

  const agregarDet = () => {
    let newRowData = [...detalles];
    let index = -(detalles?.length + 1)

    const newData = {
      IdCustomerDetails: index,
      CompanyName: '',
      IdCustomer: selected?.IdCustomer,
      RTN: '',
      Email: '',
      Tel: '',
      Contact: '',
      IdCountry: null,
      Country: '',
      City: '',
      State: '',
      Address: '',
      IdStatus: 5,
      StatusName: 'Activo',
      IsShipTo: 0,
      IsBillTo: 0,
      IsBuyer: 0,
    }
    newRowData.push(newData);
    setDetalles(newRowData);
  }

  const GuardarDatos = async () => {
    const tieneRTNInvalido = detalles.some((detalle) => !detalle.RTN)
    const tieneCompanyNameInvalido = detalles.some((detalle) => !detalle.CompanyName)
    const tieneContactInvalido = detalles.some((detalle) => !detalle.Contact)
    const tieneTelInvalido = detalles.some((detalle) => !detalle.Tel)
    const tieneEmailInvalido = detalles.some((detalle) => !detalle.Email)
    const tieneCountryInvalido = detalles.some((detalle) => !detalle.Country)
    const tieneCityInvalida = detalles.some((detalle) => !detalle.City)
    const tieneStateInvalido = detalles.some((detalle) => !detalle.State)
    const tieneAddressInvalido = detalles.some((detalle) => !detalle.Address)

    if (tieneRTNInvalido) {
      toastShow( toast, "error", "Error", "Todos los detalles deben tener un RTN válido." );
      return;
    }

    if (tieneCompanyNameInvalido) {
      toastShow( toast, "error", "Error", "Todos los detalles deben tener un Nombre válido." );
      return;
    }

    if (tieneContactInvalido) {
      toastShow( toast, "error", "Error", "Todos los detalles deben tener un contacto válido." );
      return;
    }

    if (tieneTelInvalido) {
      toastShow( toast, "error", "Error", "Todos los detalles deben tener un Tel válido." );
      return;
    }

    if (tieneEmailInvalido) {
      toastShow( toast, "error", "Error", "Todos los detalles deben tener un Email válido.");
      return;
    }


    if (tieneCountryInvalido) {
      toastShow(toast,"error","Error","Todos los detalles deben tener un COUNTRY válido.");
      return;
    }

    if (tieneCityInvalida) {
      toastShow(toast,"error","Error","Todos los detalles deben tener una City válida.");
      return;
    }

    if (tieneStateInvalido) {
      toastShow(toast,"error","Error","Todos los detalles deben tener un State válido.");
      return;
    }

    if (tieneAddressInvalido) {
      toastShow(toast,"error","Error","Todos los detalles deben tener una Address válida.");
      return;
    }

    setLoading(true)
    const Datos = detalles.map((detalle) => ({
      ...detalle,
      IdCustomer: selected?.IdCustomer,
      IdUserCreate: userAuth?.IdUser,
      IdUserEdit: userAuth?.IdUser,
    }));

    let todosGuardadosExitosamente = true; 

    for (const detalle of Datos) {
      const resp = await GuardarCustomerDetails(detalle);
      console.log("RESP GUARDAR CUSTOMER DETAILS:", resp);

      if (resp[0]?.ESTADO !==1) {
        todosGuardadosExitosamente = false;
      }
    }

    if (todosGuardadosExitosamente) {
      toastShow( toast, "success", "Guardado", "Datos guardados correctamente");
      getInfo()
    } else {
      toastShow( toast, "error", "Error", "Error al guardar datos.");
    }
    setLoading(false)
  }
  

  useEffect(() => {
    if (dialogCustomersD) {
      getInfo();
    }
  }, [dialogCustomersD]);


  return (
    <div>
      <Dialog
        visible={dialogCustomersD}
        className="modal__contenedor modal__usuarios"
        onHide={onHide}
        header={<div>
          <h4>Compradores</h4>
          <div className="d-flex gap-2">
            <Button icon="pi pi-refresh" onClick={getInfo} />
            <Button icon="pi pi-plus" onClick={agregarDet} />
            <Button icon="pi pi-save" onClick={GuardarDatos} />
            
          </div>
        </div>}
      >
      <Toast ref={toast} />
        <div id="Dialog">
          <Loader loading={loading} querySelector='#Dialog'/>
          <div className="p-4" style={{ height: "50vh" }}>
            <AgGrid table={table} />
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default CompradoresDialog;
